import React, { useEffect } from 'react';
import { translate } from '../Services/translation';
import LipscoreCustomScript from './LipscoreCustomScript'; // Import custom script

const Lipscore = ({ productName, productId, productUrl, variantId, variantName }) => {
    useEffect(() => {
        if (typeof window !== 'undefined') {
            LipscoreCustomScript();  // Invoke the custom script to handle the dynamic elements and API calls
            
        }
    }, [productId]);

    const setSelected = (event) => {
        event.currentTarget.classList.toggle('expanded');
    };

    // Prevent accordion from collapsing when clicking inside the reviews
    const handleReviewClick = (event) => {
        event.stopPropagation(); // Prevent event bubbling to accordion collapse
    };

    // Handle Load More Reviews with stopPropagation
    const handleLoadMoreClick = (event) => {
        event.stopPropagation(); // Prevents the accordion from closing
        // Logic to load more reviews (if it's not already handled in LipscoreCustomScript)
    };

    return (
        <div className="small-12 large-12 columns product-about">
            <div className="product-about__heading-container" onClick={(e) => setSelected(e)}>
                <div className="product-about__heading">
                    <h2 className="product-about__title">{translate('product.lipscore.title')}</h2>
                    <div className="product-about__icon"></div>
                </div>
                <div className="product-about__content">
                    <div id="lpsc-custom-wrapper"
                        lpsc-custom-buyer="Kund"
                        lpsc-custom-product="Produkt"
                        lpsc-lang="sv"
                        lpsc-product-id={variantId}
                        data-ls-product-name={productName}
                        data-ls-brand=""
                        data-ls-product-id={variantId}
                        data-ls-product-url={productUrl}
                        data-ls-variant-id={variantId}
                        data-ls-variant-name={variantName}>
                        <div className="lpsc-custom-badge" onClick={handleReviewClick}>
                            <div className="custom-badge-score"></div>
                            <div className="custom-badge-stars"></div>
                            <div className="custom-badge-text">Based on 0000 reviews</div>
                        </div>
                        <div id="lpsc-custom-list" onClick={handleReviewClick}></div>
                        <div className="lpsc-custom-list-footer">
                            <a
                                id="lpsc-custom-load-more"
                                style={{ display: 'none' }}
                                onClick={handleLoadMoreClick}>
                                Load More Reviews
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Lipscore;
